import { all, call, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import { getJSON, postJSON } from '../../shared/util';
import _ from 'underscore';

export function* init({ payload }) {
    const config = yield select(state => state.product.teeup);

    yield put({
        type: 'tarot-reading:update',
        payload: {
            positions: config && config.fields && config.fields[2] && config.fields[2].positions,
            type: payload.type,
        },
    });

    if (payload && payload.upc && payload.upc.match(/-1-card/)) {
        return;
    }

    if (!config.code.startsWith('mandala')) {
        yield put({
            type: 'member:reset-inactive-deck',
        });
    }

    yield put({
        type: 'price:required',
        payload: { upc: payload.upc },
    });

    yield all([
        put({ type: 'cordial:browse' }),
    ]);

    const params = yield select(state => state['query-params']);

    if (params.report) {
        yield call(reloadUnpurchased, params.report);
    }

    if (payload.upc == 'yes-or-no-tarot-redux') {
        yield put({
            type: 'tarot-reading:update',
            payload: {
                button_text: 'shuffle cards',
                source: 'Pre-Selected',
                cards: [10],
            },
        });
    }
}

function* reloadUnpurchased(product_result_uuid) {
    let response;
    try {
        response = yield call(getJSON, `/api/product/result/${product_result_uuid}`);
    } catch (e) {
        yield put({
            type: 'tarot-reading:update',
            payload: {
                error: e,
            },
        });
        return;
    }

    if (response && response.upc) {
        let not_a_sample = !response.upc.includes('sample');

        const upc = yield select(state => state.product.teeup.code);
        if (not_a_sample && response.purchased) {
        // Reading is already purchased, forward to result
            window.location.assign(`/report/${response.slug}`);
            return;
        } else if (not_a_sample && response.upc != upc) {
        // Reading is not on correct teeup page
            return;
        }
    }

    let question = response && response.inputs && response.inputs.question || '';
    yield all([
        put({ type: 'tarot-reading:update', payload: { subject: question, fixed_question: true }}),
        call(pickCards, response),
        put({
            type: 'product:update',
            payload: {
                report_slug: response.product_result_uuid,
                member_uuid: response.member_uuid,
            },
        }),
    ]);
}

const pickCards = (response) => {
    if (response && response.inputs && response.inputs.cards) {
        const card_ids = response.inputs.cards.map((selected) => selected.card_id);
        const cards = document.querySelectorAll('tarot-reading-deck-card');
        let card;
        for (let sc = 0; sc < card_ids.length; sc++) {
            for (let c = 0; c < cards.length; c++) {
                card = cards[c];

                if (Number(card.getAttribute('card_id')) == card_ids[sc]) {
                    card.dispatchEvent(new Event('mousedown'));
                    break;
                }
            }
        }
    }
};

export function* mandalaOrient() {
    const product = yield select(state => state.product);
    const positions = product && product.teeup && product.teeup.fields
        && product.teeup.fields[2] && product.teeup.fields[2].positions;
    if (positions) {
        const newPositions = positions.map(position => {
            position.orientation = _.shuffle(['upright', 'right', 'left', 'reverse'])[0];

            return position;
        });

        yield put({
            type: 'tarot-reading:update',
            payload: {
                positions: newPositions,
            },
        });
    }
}

export function* shuffleDeck() {
    const spread = yield select(state => state.spread);
    const shuffled = _.shuffle(spread.filter(card => { return card != 'picked'; }));
    const new_spread = Object.keys(spread).map(key => {
        if (spread[key] != 'picked') {
            const rand = Math.floor(Math.random() * shuffled.length);
            spread[key] = shuffled[rand];
            shuffled.splice(rand, 1);
        }

        return spread[key];
    });

    yield put({
        type: 'spread:update',
        payload: new_spread,
    });
}

export function* pickedCard({ payload }) {
    const cards = yield select(state => state['tarot-reading'].cards);

    // make sure we don't set the product type unless the user is actually
    // engaging with the reading, in the case of the widget
    if (cards && cards.length === 1) {
        yield put({
            type: 'product:update',
            payload: {
                type: 'Reading',
            },
        });
    }

    yield put({
        type: 'tarot-reading:update',
        payload: {
            error: null,
            cards: _.uniq(cards.concat(payload.card)),
        },
    });
}

export function* validateFetch() {
    const user = yield select(state => state.user);
    const { cards, positions } = yield select(state => state['tarot-reading']);

    if (cards.length !== positions.length) {
        yield put({
            type: 'tarot-reading:update',
            payload: {
                error: {
                    remaining: positions.length - cards.length,
                },
            },
        });
        return;
    }

    const upc = yield select(state => state.product.teeup.code);

    if (upc.match(/-1-card/)) {
        const data = {
            card: cards[0],
            deck_code: 'universal_waite',
            upc: upc,
        };

        yield put({
            type: 'product:update',
            payload: {
                submitting: true,
            },
        });

        const interp = yield call(getJSON, '/api/product/result/freetarot', data);

        yield all([
            put({
                type: 'product:update',
                payload: {
                    submitted: true,
                    submitting: false,
                },
            }),
            put({
                type: 'report:update',
                payload: interp,
            }),
        ]);

        return;
    }

    if (!user.logged_in) {
        yield all([
            put({
                type: 'product:update',
                payload: {
                    pending: true,
                },
            }),
            put({
                type: 'route:to',
                payload: 'login',
            }),
            take('user:logged-in'),
        ]);

        // This is an old solution
        if (! upc.includes('sample')) {
            yield call(getJSON, `/api/product/voucher/${upc}`);
        }
    }

    yield call(waitForPendingProduct);

    const [ submitting, report_slug ] = yield all([
        select(state => state.product.submitting),
        select(state => state.product.report_slug),
    ]);

    if (submitting || (report_slug && upc.includes('sample'))) {
        // Check with upc to prevent sample submitting twice, but allow upsell to happen
        return;
    }

    yield put({
        type: 'product:update',
        payload: {
            submitting: true,
        },
    });

    yield call(checkoutSubmit, cards);
}

function* getProductPending() {
    let productUpdate = yield take('product:update');
    return productUpdate.payload.pending;
}

export function* waitForPendingProduct() { // also imported by i-ching-reading.js
    const [user_uuid, product_uuid] = yield all([
        select(state => state.user && state.user.member_uuid),
        select(state => state.product && state.product.member_uuid),
    ]);

    // only allow pending products to be submitted by the same user
    if (user_uuid && product_uuid && user_uuid != product_uuid) {
        // refresh page without the ?report param if user is not the same
        const { origin, pathname } = window.location;
        const newLocation = new URL(`${origin}${pathname}`);
        window.location.href = newLocation.href;

        return;
    }

    const pending = yield select(state => state.product.pending);
    if (pending) {
        const nextRoute = yield take('route:to');
        if (nextRoute.payload == 'sms') {
            //wait for sms modal close
            let productPending = true;
            while (productPending) {
                productPending = yield call(getProductPending);
            }
        }
    }
}

function* checkoutSubmit(cards) {
    const deck = yield select(state => state.deck.code);
    const subject = yield select(state => state['tarot-reading'].subject);
    const upc = yield select(state => state.product.teeup.code);
    const report_slug = yield select(state => state.product.report_slug);

    if (/mandala/.test(upc)) { //mandala case
        const positions = yield select(state => state.product.teeup.fields[2].positions);
        cards = cards.map((card, i) => {
            return {
                card_id: card,
                orientation: positions[i] && positions[i].orientation,
                position: positions[i] && positions[i].position,
            };
        });
    } else {
        cards = cards.map((card) => Object.assign({}, { card_id: card }));
    }

    const orderInfo = {
        cards: cards,
        deck_code: deck,
        question: subject,
        upgrade_slug: report_slug,
    };

    try {
        const order = yield call(postJSON, `/api/product/submit/${upc}`, orderInfo);
        yield put({
            type: 'location:href',
            payload: order.forwarding_url,
        });
    } catch (e) {
        yield all([
            put({
                type: 'tarot-reading:update',
                payload: {
                    interps: {
                        error: e,
                    },
                },
            }),
            yield put({
                type: 'product:update',
                payload: {
                    submitting: false,
                },
            }),
        ]);
    }
}

export function* watchFavoriteDeck() {
    while (true) {
        const { payload: user } = yield take('user:update');
        const favorite_deck = yield call(getFavoriteDeck, user);
        const deck = yield select(state => state.deck);

        let deck_code = null;

        if (deck && deck.code && deck.code != 'mandala') {
            if (favorite_deck && favorite_deck.code) {
                deck_code = favorite_deck.code;
            }
        }

        if (deck_code) {
            yield put({
                type: 'deck:required',
                payload: deck_code,
            });
        }
    }
}

function* getFavoriteDeck(user) {
    if (!user.favorite_deck_id) {
        return null;
    }

    const decks = yield select(state => state.decks);

    if (!decks || !decks.length) {
        return null;
    }

    return decks.find(deck => deck.deck == user.favorite_deck_id);
}


export function* root() {
    yield all([
        fork(watchFavoriteDeck),
        takeEvery('tarot-reading:init', init),
        takeEvery('tarot-reading:orient', mandalaOrient),
        takeEvery('tarot-reading:shuffle-deck', shuffleDeck),
        takeEvery('tarot-reading:picked', pickedCard),
        takeEvery('tarot-reading:fetch', validateFetch),
    ]);
}
